import { render } from "./BrickSvg.vue?vue&type=template&id=2b921dfc"
import script from "./BrickSvg.vue?vue&type=script&lang=js"
export * from "./BrickSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__